// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 145) return "static/chunks/145-09af763c1120fe0d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"235":"6673903345b4dd03","537":"0ad23ed8355a7989","697":"0e57f78e595fb6b8","784":"37ab4b9839be66b2"}[chunkId] + ".js";
};